import Switch from '@/components/Common/Switch';
import { Box, Typography } from '@mui/material';

const ModeToggleField = ({
  namePrefix,
  control,
  disabled
}: {
  namePrefix: string;
  control: any;
  disabled?: boolean;
}) => {
  return (
    <Box display='flex' alignItems='center' width='100%' mt={2}>
      <Typography variant='h6' fontSize={15} fontWeight={500}>
        Test
      </Typography>
      <Switch name={`${namePrefix}.live_mode`} control={control} disabled={disabled} />
      <Typography variant='h6' fontSize={15} fontWeight={500}>
        Live
      </Typography>
    </Box>
  );
};

export default ModeToggleField;
